import { render } from "./IconAdd.vue?vue&type=template&id=d03962a6"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconAdd.vue"]])

export default __exports__